import { Directive, Input, TemplateRef } from '@angular/core';
import { IUserSessionData } from '../../../store/models/user.model';

@Directive({
  selector: '[appTableMobileRow]',
})
export class TableMobileRowDirective {

  @Input() row: any;
  @Input() currentUser: IUserSessionData;

  constructor(public templateRef: TemplateRef<any>) {
  }
}
